import { gql } from '@apollo/client';

export const SET_TXIMPORT_PREVIEW_SKIPPED = gql`
  mutation SetTxImportPreviewSkipped($rowId: ID!, $skipped: Boolean!) {
    setTximportPreviewSkipped(rowId: $rowId, skipped: $skipped) {
      id
      skipped
      isValid
    }
  }
`;

export const SET_TXIMPORT_JOB_CANCELED = gql`
  mutation SetTxImportJobCanceled($jobId: ID!) {
    setTximportJobCanceled(jobId: $jobId) {
      id
      status
      stage
      updatedAt
    }
  }
`;

export const UPDATE_TXIMPORT_PREVIEW_TRANSACTION = gql`
  mutation UpdateTxImportPreviewTransaction($rowId: ID!, $input: TxImportPreviewTransactionUpdateInput!) {
    updateTximportPreviewTransaction(rowId: $rowId, input: $input) {
      id
      jobId
      portfolioId
      stockId
      rawIsin
      rawExchange
      tokenId
      token {
        id
        ticker
        name
      }
      rawTicker
      rawCoingeckoId
      rawLocation
      rawSourceLocation
      rawDestinationLocation
      resolvedTokenName
      transactionType
      price
      quantity
      timestamp
      fees
      feeQuantity
      notes
      currency
      brokerBaseCurrency
      brokerFXRate
      brokerBaseAmount
      fxRateToUSD
      fxSource
      skipped
      isValid
      validationErrors {
        field
        message
      }
    }
  }
`;

export const START_TXIMPORT = gql`
  mutation StartTxImport($jobId: ID!) {
    startTximport(jobId: $jobId) {
      id
      status
      stage
    }
  }
`;

export const SET_TXIMPORT_PREVIEW_TOKEN = gql`
  mutation SetTxImportPreviewToken($rowIds: [ID!]!, $tokenId: ID, $coingeckoApiId: String) {
    setTximportPreviewToken(rowIds: $rowIds, tokenId: $tokenId, coingeckoApiId: $coingeckoApiId) {
      id
      tokenId
      isValid
      validationErrors {
        field
        message
      }
    }
  }
`;

export const SET_TXIMPORT_PREVIEW_STOCK = gql`
  mutation SetTxImportPreviewStock($rowIds: [ID!]!, $stockId: ID, $symbol: String) {
    setTximportPreviewStock(rowIds: $rowIds, stockId: $stockId, symbol: $symbol) {
      id
      stockId
      isValid
      token {
        id
        ticker
        name
      }
      validationErrors {
        field
        message
      }
    }
  }
`;

export const DELETE_TXIMPORT_JOB = gql`
  mutation DeleteTxImportJob($jobId: ID!) {
    deleteTximportJob(jobId: $jobId) {
      id
      status
    }
  }
`;

export const UPDATE_TXIMPORT_MAPPING = gql`
  mutation UpdateTxImportMapping($jobId: ID!, $fields: [TxImportMappingFieldInput!]!) {
    updateTximportMapping(jobId: $jobId, fields: $fields) {
      id
      status
      stage
    }
  }
`;

